export default __webpack_public_path__ + "static/media/import-progress.e700f201.svg";